import { ProductIdentifierDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

export class ProductCompareIcon {
  public productIdentifier: ProductIdentifierDto | undefined;
  public isInComparison: boolean | undefined = false;
}
